import React, { useEffect, useState } from 'react'
import { createPortal } from 'react-dom'
import { useLocation, useParams } from 'react-router'
import { useMediaQuery } from 'react-responsive'
import Skeleton from 'react-loading-skeleton'
import { usePortal } from '../hooks/usePortal'
import { useAxios } from '../hooks/useAxios'
import Breadcrumbs from '../components/Breadcrumbs'
import getArticle from '../api/getArticle'
import TextContent from '../components/TextContent'
import { getReward } from '../api/getReward'
import { toast } from 'react-toastify'
import Btn from '../components/Btn'
import Dialog from '../components/Dialog'
import Card from '../components/Card'
import { formatNumber } from '../utils/countDictinary'
import { UserStore } from '../store/userStore'
import NotFound from '../components/NotFound'
import { QuestForm } from '../components/QuestControls/QuestForm'
import { postArticleQuest } from '../api/postArticleQuest'
import { IQuest } from '../server/quests'

interface Props {
  type: 'article' | 'task'
}

const BREADCRUMBS = [
  {
    label: 'Главная',
    path: '/'
  }
]

const ArticleBasePage: React.FC<Props> = ({ type }) => {
  const [breadcrumbs, setBreadcrumbs] = useState(BREADCRUMBS)
  const [loading, setLoading] = useState<boolean>(true)
  const { id } = useParams()
  const { pathname } = useLocation()
  const { portal } = usePortal()
  const isTablet = useMediaQuery({
    query: '(max-width: 1023px)'
  })

  const { response, fire, error } = useAxios()
  const {
    response: rewardResponse,
    fire: rewardFire,
    loading: rewardLoading
  } = useAxios()
  const [rewardPopup, setRewardPopup] = useState(false)
  const [rewardIsDisabled, setRewardIsDisabled] = useState(false)
  const [quest, setQuest] = useState<IQuest | null>(null)
  const [isActive, setIsActive] = useState(false)
  const [validationPopup, setValidationPopup] = useState(false)

  useEffect(() => {
    fire(getArticle(`/${type}s/item`, id ?? '')).then(({ response, error }) => {
      if (!error) {
        const newBreadCrumbs = [
          ...BREADCRUMBS,
          { label: response?.data?.title, path: pathname }
        ]
        setBreadcrumbs(newBreadCrumbs)
        setRewardIsDisabled(response?.data?.reward)
        setQuest(response?.data?.quest)
        setIsActive(response?.data?.quest?.isActive ?? false)
      }

      setLoading(false)
    })
  }, [])

  const rewardHandler = async () => {
    const { response: res, error } = await rewardFire(
      getReward(response?.data?.id ?? '')
    )

    if (error) {
      toast.error(error.message)
      return
    }

    localStorage.setItem('token', res?.data?.token)
    UserStore.updateUserData()
    setRewardIsDisabled(true)
    setRewardPopup(true)
  }

  const handleSubmit = async (data: any) => {
    const { response: res, error } = await rewardFire(
      postArticleQuest(id as string, data)
    )

    if (error) {
      toast.error(error.message)
      return
    }

    if (res) {
      toast.success('Результаты успешно отправлены')
      setIsActive(false)
      setValidationPopup(true)
    }
  }

  return (
    <div className={'page'}>
      {error?.response?.status === 404 ? (
        <NotFound></NotFound>
      ) : error ? (
        <div className={'page__content'}>{error.message}</div>
      ) : (
        <>
          {loading && isTablet ? (
            <div className="breadcrumbs">
              <Skeleton width="10rem" />
              <Skeleton width="10rem" />
              <Skeleton width="10rem" />
            </div>
          ) : (
            <Breadcrumbs
              className={'page__breadcrumbs'}
              breadcrumbs={breadcrumbs}
            />
          )}
          {portal &&
            createPortal(
              loading ? (
                <div className="breadcrumbs">
                  <Skeleton width="10rem" />
                  <Skeleton width="15rem" />
                  <Skeleton width="24rem" />
                </div>
              ) : (
                <Breadcrumbs breadcrumbs={breadcrumbs} />
              ),
              portal
            )}

          <header className="page__head d-block">
            {loading ? (
              <Skeleton height="5.2rem" width={'75%'}></Skeleton>
            ) : (
              <h1>{response?.data?.title}</h1>
            )}
          </header>
          <div className="page__content article-page">
            <div className="article-page__row">
              <div className="article-page__col">
                {loading ? (
                  <>
                    <Skeleton count={12} />
                  </>
                ) : (
                  <div className="article-page__content">
                    <TextContent
                      content={response?.data?.detailText}
                    ></TextContent>
                    {type === 'task' && quest && quest?.items?.length > 0 ? (
                      <>
                      <QuestForm
                        quest={quest}
                        onSubmit={handleSubmit}
                        isSubmitting={false}
                        isActive={isActive}
                      />
                      <Dialog
                      render={() => {
                        return (
                          <Card
                            className={
                              'u-flex u-flexCol u-flexAlignItemsCenter reward-popup'
                            }
                            style={{ maxWidth: '40rem' }}
                          >
                            <header className={'card-head _centered'}>
                              <p
                                className={'card-head__title text-h3'}
                              >{`Баллы будут начислены после проверки администратором`}</p>
                            </header>

                            <div
                              className={'card-content reward-popup__picture'}
                            >
                              <img src={'/i/hourglass.png'} alt={'hourglass'} />
                            </div>

                            <footer className={'card-foot'}>
                              <Btn to={'/'}>Вернуться в личный кабинет</Btn>
                            </footer>
                          </Card>
                        )
                      }}
                      value={validationPopup}
                    ></Dialog>
                    </>
                    ) : undefined}
                  </div>
                )}
              </div>
              <div className="article-page__col"></div>
            </div>
            {!response?.data?.quest && response?.data?.hasReward || response?.data?.hasParticipation ? (
              <div className={'article-page__actions'}>
                {response?.data?.hasReward ? (
                  <>
                    <Btn
                      onClick={rewardHandler}
                      disabled={rewardIsDisabled || isActive}
                      loading={rewardLoading}
                    >
                      Получить награду
                    </Btn>
                    <Dialog
                      render={() => {
                        return (
                          <Card
                            className={
                              'u-flex u-flexCol u-flexAlignItemsCenter reward-popup'
                            }
                            style={{ maxWidth: '40rem' }}
                          >
                            <header className={'card-head _centered'}>
                              <p
                                className={'card-head__title text-h3'}
                              >{`Вы заработали ${rewardResponse?.data
                                ?.balls} ${formatNumber(
                                rewardResponse?.data?.balls,
                                'balls'
                              )}`}</p>
                            </header>

                            <div
                              className={'card-content reward-popup__picture'}
                            >
                              <img src={'/i/checkmark.png'} alt={'checkmark'} />
                            </div>

                            <footer className={'card-foot'}>
                              <Btn to={'/'}>Вернуться в личный кабинет</Btn>
                            </footer>
                          </Card>
                        )
                      }}
                      value={rewardPopup}
                    ></Dialog>
                  </>
                ) : null}
                {response?.data?.eventUrl ? (
                  <Btn outlined to={response?.data?.eventUrl}>
                    Подать заявку
                  </Btn>
                ) : null}
              </div>
            ) : null}
          </div>
        </>
      )}
    </div>
  )
}

export default ArticleBasePage
